import { Group, TextInput, Box, Text, Code, Button, Center, LoadingOverlay, Select, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import { AppDataService } from '../../services/AppDataService';
import useInfoModal from '../../hooks/useInfoModal';
import { MODAL_TYPE_ENUM } from '../../enums/CommonEnums';
import { useState } from 'react';
import { EditSubmissionFormValidations } from './validations/FormValidations';
import { useEffect } from 'react';

const ReviewSubmissionForm = ({ submissionRecord, onSubmit }) => {
  const openModal = useInfoModal();
  const [loading, setLoading] = useState(false);

  const form = useForm({
    initialValues: submissionRecord,
    validate: {
    }
  });

  const handleFormSubmit = async (values) => {
    try {
      setLoading(true);
  
      const webResp = await AppDataService.AdminReviewContainerRegistration({ 
        registration: {
          id: submissionRecord.id, 
          ...form.values
        },
        statusId: form.values.reviewStatusId,
        notes: form.values.reviewNotes
      });
      const responseData = webResp.getResponse();
  
      if(webResp.hasError()) {
        setLoading(false);
        return openModal(MODAL_TYPE_ENUM.GENERAL_FAILURE, responseData.error.message);
      } 

      onSubmit(responseData.data.registration);
  
      setLoading(false);
    }
    catch(err) {
      setLoading(false);
      openModal(MODAL_TYPE_ENUM.GENERAL_FAILURE, err.message);
    }
  }

  return (
    <Box mx="auto">
      <LoadingOverlay visible={loading} overlayBlur={2} />

      <Stack>
        <Text fw='bold'>Reviewing submission from {submissionRecord?.user?.firstName} at {submissionRecord?.user?.companyName}</Text>
        <Text fw='bold'>This submission was made on {submissionRecord.dateSubmitted}</Text>
        <TextInput disabled size='md' placeholder="UPC/EAN" {...form.getInputProps(`upc`)} label='UPC' />
        <TextInput disabled size='md' placeholder="Product Brand & Name" {...form.getInputProps('productName')} label='Product' />
        <TextInput disabled size='md' placeholder="Size (oz)" {...form.getInputProps(`size`)} label='Size' />
        <Select
          label='Review Status'
          withinPortal={true}
          dropdownPosition='bottom'
          size='md'
          placeholder='Material'
          {...form.getInputProps('reviewStatusId')}
          data={[
            {value: 1, label: 'Pending' },
            {value: 2, label: 'Completed' },
            {value: 3, label: 'Rejected' },
          ]}
        />
        <TextInput size='md' placeholder="Review Notes" {...form.getInputProps(`reviewNotes`)} label='Review Notes' />
      </Stack>

      <Group position="center" mt="md">
        <Button color='dark' onClick={form.onSubmit(handleFormSubmit)} loading={loading}>Submit</Button>
        <Button color='dark' onClick={() => form.reset()}>Reset</Button>
      </Group>
    </Box>
  );
}

export default ReviewSubmissionForm;